// @flow
/* eslint-disable camelcase */
import * as React from 'react';

import Avatar from 'components/Avatar.jsx';
import AvatarContactabilityBadge from 'components/AvatarContactabilityBadge.jsx';
import AvatarReachabilityBadge from 'components/AvatarReachabilityBadge.jsx';
import Feature from 'components/Feature.jsx';

import type { AvatarSize } from 'components/Avatar.jsx';
import type { ReachabilityInfo } from 'components/ReachabilityBadge.jsx';

// This type does not protect against accessing fields that do not exist
// because a User exists in way too many forms across frontend
export type UnsafePartialUser = $Shape<{
  initials?: ?string,
  profilePictureUrl?: ?string,
  contactabilityStatus?: ?ContactabilityStatus,
  profile_picture_url?: ?string,
  profile_picture?: ?{
    urls: {|
      __typename: 'FileUrls',
      cdn: ?string,
    |},
  },
  contactability_status?: ?ContactabilityStatus,
  avatarUrl?: ?string,
  reachabilityInfo?: ReachabilityInfo,
  reachability_info?: ReachabilityInfo,
  [any]: any,
}>;

type Props = {
  user: ?UnsafePartialUser,
  color?: ?'brand' | 'grey' | 'fullGrey' | 'white',
  size?: AvatarSize,
  className?: ?string,
  hideBadge?: boolean,
  disableBadgeHover?: boolean,
};

/* Pass a JSON user into this component and it will correctly render
 * an Avatar based on the available data */

export default class UserAvatar extends React.Component<Props> {
  render() {
    const { color, size, className, user, hideBadge, disableBadgeHover } = this.props;
    const blankAvatar = <Avatar color={color} size={size} className={className} text="??" />;

    if (!user) {
      return blankAvatar;
    }

    const {
      initials,
      profilePictureUrl,
      profile_picture_url,
      contactabilityStatus,
      contactability_status,
      avatarUrl,
      profile_picture,
      reachabilityInfo,
      reachability_info,
    } = user;

    const contactabilityBadge =
      contactabilityStatus || contactability_status ? (
        <AvatarContactabilityBadge
          hoverable={!disableBadgeHover}
          status={contactabilityStatus || contactability_status}
        />
      ) : (
        undefined
      );

    const reachabilityBadge =
      reachabilityInfo || reachability_info ? (
        <AvatarReachabilityBadge
          hoverable={!disableBadgeHover}
          reachability={reachabilityInfo || reachability_info}
        />
      ) : (
        undefined
      );

    const badge = hideBadge ? (
      undefined
    ) : (
      <Feature
        name="2018.oct.web.reachability_status"
        on={reachabilityBadge}
        off={contactabilityBadge}
      />
    );

    if (profile_picture) {
      return (
        <Avatar
          color={color}
          size={size}
          className={className}
          image={profile_picture.urls.cdn}
          badge={badge}
        />
      );
    }

    if (profilePictureUrl || profile_picture_url || avatarUrl) {
      return (
        <Avatar
          color={color}
          size={size}
          className={className}
          image={profilePictureUrl || profile_picture_url || avatarUrl}
          badge={badge}
        />
      );
    }

    if (initials) {
      return (
        <Avatar color={color} size={size} className={className} text={initials} badge={badge} />
      );
    }

    return blankAvatar;
  }
}
